import React from "react"
import PortableText from "react-portable-text"
import AutoLink from "components/AutoLink"

const SimpleText = props => (
  <PortableText serializers={{ link: AutoLink }} {...props} />
)

export default SimpleText
